import cn from "classnames"

import { Flex } from "@/atoms"
import { CaretDownOutlined, CaretUpOutlined } from "@/icons"

import styles from "./Trend.module.scss"

import type { TrendProps } from "./Trend.types"

export const Trend = (props: TrendProps) => {
  const { variant, value, percentage, justify } = props
  const isUp = variant === "up"
  const isDown = variant === "down"

  return (
    <Flex gap={4} align="center" justify={justify}>
      {value !== undefined && <span>{value}</span>}
      {percentage !== undefined && (
        <Flex
          className={cn(styles.trend, {
            [styles.trendUp]: isUp,
            [styles.trendDown]: isDown
          })}
        >
          {isDown && <CaretDownOutlined className={styles.icon} />}
          {isUp && <CaretUpOutlined className={styles.icon} />}
          {variant === "equal" && <span className={styles.trendEqual} />}
          <span className={styles.percentage}>{`${percentage}%`}</span>
        </Flex>
      )}
    </Flex>
  )
}
